export enum Gender {
	female,
	male,
	other
}

export type GenderKeys = keyof typeof Gender;